import { FC } from 'react';
import Calendar from 'images/calendar-icon.svg';

const CalendarIcon: FC = () => {
  return <img src={Calendar} alt="calendar-icon" />;
};
export default CalendarIcon;
